import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { Button } from '@mui/material';

import {
  getAdminBrokerProposals,
  brokerProposalsSelector,
  brokerbrokerProposalsMetaSelector,
  isLoadingBrokerProposalsSelector,
  brokerImpersonate,
} from 'src/store/admin';

import { Status } from '../Status/Status';
import moment from 'moment';

export const useTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const data = useSelector(brokerProposalsSelector);
  const metaData = useSelector(brokerbrokerProposalsMetaSelector);
  const isLoading = useSelector(isLoadingBrokerProposalsSelector);

  const [, setCookie] = useCookies(['is_impersonate']);

  // TODO
  const onClickImpersonate = useCallback(
    (item) => async () => {
      console.log('item', item);

      const url = item?.org?.id
        ? `/teams/${item?.org?.id}/accounts/${item.account_id}/proposals/${item.proposal_id}/account-info`
        : `/accounts/${item.account_id}/proposals/${item.proposal_id}/account-info`;

      const user_id = item?.broker?.id;

      const payload = {
        url,
        user_id,
        navigate,
      };

      await dispatch(brokerImpersonate(payload));
      setCookie('is_impersonate', 'true', { path: '/' });
    },
    [dispatch, navigate, setCookie],
  );

  const build = {
    title: 'Brokers Proposals',
    filters: [
      // {
      //   id: 'q',
      //   label: 'Search',
      //   type: 'search-input',
      // },
    ],
    columns: [
      {
        id: 'account_name',
        name: 'Account Name',
        sortable: true,
      },
      {
        id: 'proposal_name',
        name: 'Proposal Name',
        sortable: true,
      },
      {
        id: 'broker',
        name: 'Broker',
        value: (value) => {
          const broker = value?.broker;

          return `${broker?.display_name}\n${broker?.email}`;
        },
        style: {
          whiteSpace: 'pre-line',
        },
        sortable: true,
      },
      {
        id: 'org',
        name: 'Org',
        value: (value) => {
          const org = value?.org;

          const isValue = org?.name;

          return isValue ? org?.name : '-';
        },
        style: {
          whiteSpace: 'pre-line',
        },
        sortable: true,
      },
      {
        id: 'due_date',
        name: 'Due Date',
        sortable: true,
      },
      {
        id: 'effective_date',
        name: 'Effective Date',
        sortable: true,
      },
      {
        id: 'created_timestamp',
        name: 'Created Date',
        sortable: true,
        value: (item) => moment(item?.created_timestamp).format('lll'),
      },
      {
        id: 'status',
        name: 'Status',
        value: (item) => <Status status={item?.status} />,
        sortable: true,
      },
      {
        id: '1',
        name: '',
        value: (item) => (
          <Button variant="contained" onClick={onClickImpersonate(item)} size="small">
            Impersonate
          </Button>
        ),
        sortable: false,
      },
    ],
    data: data,
    meta: metaData,
    api: {
      get: getAdminBrokerProposals,
    },
    is_loading: isLoading,
  };

  return { build };
};
